/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */

import React from 'react';

export const AuthenticationGuard = ({ component }: { component: React.ComponentType<object> }) => {
    // Since we're protecting the app from unauthenticated user at the root level
    // (e.g. main.tsx), we don't need to do anything here.
    // Let's leave this component here for future use.
    const Component = component;

    return <Component />;
};
